import { action } from 'typesafe-actions'
import { DashboardActionTypes } from './types'

// Search Request
export const listRequest = (searchParams:any) => action(DashboardActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: any[]) => action(DashboardActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(DashboardActionTypes.LIST_ERROR, errors)